module.exports = __webpack_public_path__ + "static/img/activity1.eb7ad4ce.png";